var _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgDiamond = function SvgDiamond(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m34.686 10.666 7.785 13.468H21.589l7.785-13.468h5.312Zm3.892 0 7.785 13.468h10.97a4.676 4.676 0 0 0-.42-.879l-6.23-10.312c-.835-1.393-2.4-2.277-4.044-2.277h-8.06Zm18.646 16.835H43.399l-9.413 25.832a4.667 4.667 0 0 0 1.353-.936l20.873-23.41a4.7 4.7 0 0 0 1.012-1.486Zm-27.664 25.6-9.33-25.6H6.783c.23.543.563 1.049.995 1.486l20.874 23.41c.278.277.584.511.909.704ZM6.666 24.134c.104-.301.24-.596.41-.879l6.229-10.312c.836-1.393 2.4-2.277 4.045-2.277h8.13l-7.785 13.468H6.667Zm33.145 3.367-7.997 21.945L23.818 27.5h15.994Z",
    fill: "currentColor"
  })));
};
export default SvgDiamond;